import React from "react";
import { Container, Grid, Paper } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import data from "../../asset/projects/data";
import "./Projects.css";

const Projects = () => {
  return (
    <Container>
      <h2 style={{ marginBottom: 30 }}>Projects</h2>
      <Grid container spacing={2}>
        {data.map((proj, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card sx={{ maxWidth: 345, height: "25rem" }} elevation={3}>
              <a href={proj.link} target="_blank" rel="noopener noreferrer">
                <CardMedia
                  component="img"
                  alt="green iguana"
                  height="140"
                  image={proj.img}
                />
              </a>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {proj.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {proj.des}
                </Typography>

                <Typography
                  variant="body2"
                  style={{ marginTop: 20, width: 30 }}
                  color="text.secondary"
                  sx={{ display: "flex" }}
                >
                  {proj.tags.map((tg, idx) => (
                    <Paper elevation={3} className="tags">
                      {tg}
                    </Paper>
                  ))}
                </Typography>
              </CardContent>
              <CardActions>
                <a href={proj.link} target="_blank" rel="noopener noreferrer">
                  <button className="button">Live</button>
                </a>
                <a href={proj?.front} target="_blank" rel="noopener noreferrer">
                  <button className="button">FrontEnd</button>
                </a>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Projects;
